/* eslint-disable no-plusplus */
angular.module('unergie.main')
.factory('Sequentializer', () => {
    const mapSeries = (array, func, result = []) => {
        if (!array || !array.length) {
            return result
        }
        return func(array.shift()).then((res) => {
            result.push(JSON.stringify(res))
        })
        .catch((error) => {
            result.push(JSON.stringify(error))
        })
        .then(() => {
            return mapSeries(array, func, result)
        })
    }

    function delay(ms) {
        return new Promise((resolve) => {
            setTimeout(resolve, ms)
        })
    }

    const map = (array, mapper, options = {}) => {
        let concurrency = options.concurrency || Infinity
        const wait = options.delay || 50

        let index = 0
        const results = []
        const pending = []

        while (concurrency-- > 0) {
            const thread = wrappedMapper()
            if (thread) {
                pending.push(thread)
            } else {
                break
            }
        }

        return Promise.all(pending).then(() => {
            return results
        })

        function wrappedMapper() {
            if (index >= array.length) {
                return null
            }
            const i = index++
            return mapper(array[i])
            .then((resolved) => {
                results[i] = resolved
                return delay(wait).then(() => {
                    if (options.switchObject.running) {
                        return wrappedMapper()
                    }
                })
            })
        }
    }

    return {
        mapSeries,
        map,
    }
})
